import { useEffect, useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Box, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import { AccessTime } from '@mui/icons-material';
import { MobileTimePicker } from '@mui/x-date-pickers';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const NewOpInfo = (props: Props) => {
  const { disabled, register, watch, setValue, getValues } = props;

  const [postureEtc, setPostureEtc] = useState(0);

  const position_labels = [
    'Fowler',
    'Lateral',
    'Lithotomy',
    'Orthopnea',
    'Prone',
    'Recumbent',
    'Sims',
    'Supine',
  ];

  const contents = [
    {
      label: '手術日期',
      element: (
        <Form.MuiTextField
          type="date"
          InputLabelProps={{ shrink: true }}
          required={false}
          disabled={disabled}
          {...register('operation_information.operating_date')}
        />
      ),
    },
    {
      label: '手術前診斷',
      element: (
        <Form.MuiTextField
          {...register('operation_information.operating_department')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '手術後診斷',
      element: (
        <Form.MuiTextField
          {...register('operation_information.operating_time')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '手術名稱',
      element: (
        <Form.MuiTextField
          {...register('operation_information.asa_class')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '手術地點',
      element: (
        <Form.MuiTextField
          {...register('operation_information.main_operation_name')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '皮膚狀況',
      element: (
        <Form.MuiTextField
          {...register('operation_information.minor_operation_name')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '皮膚準備',
      element: (
        <Form.MuiTextField
          {...register('operation_information.past_history')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '手術體位',
      element: (
        <Form.MuiTextField
          select
          required={false}
          disabled={disabled}
          defaultValue={getValues('operation_information.allergy')}
          {...register('operation_information.allergy')}
        >
          <MenuItem value="Supine">仰臥</MenuItem>
          <MenuItem value="Trendelenburg">特倫德倫堡</MenuItem>
          <MenuItem value="Reverse Trendelenburg">反特倫德倫堡</MenuItem>
          <MenuItem value="Fowler's">福勒氏體位</MenuItem>
          <MenuItem value="Semi-Fowler's">半福勒氏體位</MenuItem>
          <MenuItem value="Lithotomy">截石位</MenuItem>
          <MenuItem value="Lateral (Left)">側臥 (左)</MenuItem>
          <MenuItem value="Lateral (Right)">側臥 (右)</MenuItem>
          <MenuItem value="Prone">俯臥</MenuItem>
          <MenuItem value="Jackknife">刀背位</MenuItem>
          <MenuItem value="Direct Input">直接輸入</MenuItem>
        </Form.MuiTextField>
      ),
    },
    {
      label: '禁食',
      element: (
        <Form.MuiTextField
          select
          required={false}
          disabled={disabled}
          defaultValue={getValues('operation_information.npo_status')}
          {...register('operation_information.npo_status')}
        >
          <MenuItem value="금식">禁食</MenuItem>
          <MenuItem value="금식안함">非禁食</MenuItem>
        </Form.MuiTextField>
      ),
    },
    {
      label: '預防性抗生素',
      element: (
        <Form.MuiTextField
          select
          required={false}
          disabled={disabled}
          defaultValue={getValues(
            'operation_information.prophylactic_antibiotics'
          )}
          {...register('operation_information.prophylactic_antibiotics')}
        >
          <MenuItem value="Injection">注射</MenuItem>
          <MenuItem value="None">無</MenuItem>
        </Form.MuiTextField>
      ),
    },

    {
      label: '過敏',
      element: (
        <Box display="flex">
          {/* <Form.MuiTextField
            select
            required={false}
            disabled={disabled}
            sx={{ width: `${postureEtc ? '18%' : '37%'}` }}
            defaultValue={
              [...position_labels, undefined].includes(
                getValues('operation_information.position')
              )
                ? getValues('operation_information.position')
                : 'etc'
            }
            {...register('operation_information.position')}
            onChange={e => {
              if (e.target.value === 'etc') setPostureEtc(1);
              else setPostureEtc(0);
            }}
          >
            {position_labels.map(v => (
              <MenuItem value={v}>{v} position</MenuItem>
            ))}
            <MenuItem value="etc">Direct input</MenuItem>
          </Form.MuiTextField>
          {postureEtc ? (
            <Form.MuiTextField
              {...register('operation_information.position_etc')}
              placeholder="Direct input"
              sx={{ marginLeft: '5px', width: '18%' }}
            />
          ) : null} */}
          <Form.MuiTextField
            {...register('operation_information.position')}
            required={false}
            sx={{ width: '37%' }}
            disabled={disabled}
          />
          <FormControlLabel
            disabled={disabled}
            control={
              <Checkbox
                defaultChecked={getValues(
                  'operation_information.preoperative_xray'
                )}
                {...register('operation_information.preoperative_xray')}
              />
            }
            label="手術前X光"
            sx={{ marginLeft: '20px' }}
          />
          <FormControlLabel
            disabled={disabled}
            control={
              <Checkbox
                defaultChecked={getValues(
                  'operation_information.preoperative_ekg'
                )}
                {...register('operation_information.preoperative_ekg')}
              />
            }
            defaultValue={getValues('operation_information.preoperative_ekg')}
            label="手術後心電圖"
            sx={{ marginLeft: '20px' }}
          />
        </Box>
      ),
    },
  ];

  useEffect(() => {
    if (
      ![...position_labels, undefined].includes(
        getValues('operation_information.position')
      )
    ) {
      setValue(
        'operation_information.position_etc',
        getValues('operation_information.position')
      );
      setPostureEtc(1);
    }
  }, []);

  return (
    <>
      <SectionTitle title="手術信息" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => (
          <>
            <RowContent
              title={label}
              titleRatio={1}
              childrenRatio={label === '過敏' ? 5 : 2}
            >
              {element}
            </RowContent>
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default NewOpInfo;
